import { render, staticRenderFns } from "./MAM_activShow.vue?vue&type=template&id=d2249220&scoped=true&"
import script from "./MAM_activShow.vue?vue&type=script&lang=js&"
export * from "./MAM_activShow.vue?vue&type=script&lang=js&"
import style0 from "./MAM_activShow.vue?vue&type=style&index=0&id=d2249220&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2249220",
  null
  
)

export default component.exports